import React, { useState, useEffect } from "react";
import {
    useDisclosure,
    Button,
    Checkbox,
    Flex,
    Text,
    Textarea,
    Collapse,
    IconButton,
    Tooltip,
    AlertDialog,
    AlertDialogOverlay,
    AlertDialogContent,
    AlertDialogHeader,
    AlertDialogBody,
    AlertDialogFooter,
    CloseButton,
    ModalBody,
    ModalHeader,
    Modal,
    ModalFooter,
    ModalOverlay,
    ModalContent,
} from "@chakra-ui/react";
import { ViewIcon } from "@chakra-ui/icons";
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../Redux";
import { useParams, useHistory } from "react-router-dom";
import { Select } from "antd";
import axios from "axios";

import { LoaderDiv, TButton } from "./trelloStyle";
import { Icons } from "../../Utils";
// NEW: RS form base URL (view mode link ke liye)
import { API, baseURL, mmh_rsform_BaseURL } from "../../Services";
import toast from "react-hot-toast";
import { SpinLoader } from "../../Components";
import UploadAttachment from "./Attachements/UploadAttachment";

const TrelloCheckList = (props) => {
    const state = useSelector((state) => state);
    const {
        isOpen: isDeleteOpen,
        onOpen: onDeleteOpen,
        onClose: onDeleteClose,
    } = useDisclosure();
    const {
        isOpen: isMemberOpen,
        onOpen: onMemberOpen,
        onClose: onMemberClose,
    } = useDisclosure();
    const {
        isOpen: isUploadOpen,
        onOpen: onUploadOpen,
        onClose: onUploadClose,
    } = useDisclosure();
    const [uploadData, setUploadData] = useState({});
    const dispatch = useDispatch();
    const [taskName, setTaskName] = useState("");
    const [isLoader, setLoader] = useState(false);
    const [isAssigned, setAssigned] = useState(false);
    const { trelloCheckList, trelloCardInfo, trelloCommentList } =
        bindActionCreators(actionCreators, dispatch);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [isAddItem, setIsAddItem] = useState(null);
    const [selectedItem, setSelectedItem] = useState("");
    const [isAddList, setIsAddList] = useState(false);
    const [editItem, setEditItem] = useState(null);
    const { id } = useParams();
    const history = useHistory();
    const { Option } = Select;
    const [selectedMemberId, setSelectedMemberId] = useState(null);

    const [inventoryMap, setInventoryMap] = useState({});
    const [inventoryMapByName, setInventoryMapByName] = useState({});
    

    const normalizeName = (name = "") => String(name).trim().toLowerCase();

    const getInventoryInfo = (cItem) => {
        // pehle ID-based map check karo — sabse accurate source
        if (cItem?.ID && inventoryMap[cItem.ID]) {
            return inventoryMap[cItem.ID];
        }
        // phir name-based map
        const nameKey = normalizeName(cItem?.name);
        if (nameKey && inventoryMapByName[nameKey]) {
            return inventoryMapByName[nameKey];
        }
        // fallback — cItem ke apne fields se (agar map me nahi mila)
        if (cItem?.projectVersion || cItem?.inventoryId) {
            return {
                projectVersion: cItem?.projectVersion || "",
                inventoryId: cItem?.inventoryId || "",
                hasRsform: cItem?.hasRsform || null,
            };
        }
        return null;
    };

    const getRsFormSuffix = (name = "") => {
        const n = String(name).toLowerCase();
        if (n.includes("structure")) return "structure";
        if (n.includes("interior")) return "interior";
        if (n.includes("elevation")) return "elevation";
        if (n.includes("floor") || n.includes("plan") || n.includes("working"))
            return "planning";
        return "planning"; // default
    };

    const openRsFormViewMode = (suffix, rsVersion = "") => {
        // TESTING - localhost:3002
        // const RS_FORM_BASE = "http://localhost:3002/";
        const RS_FORM_BASE = mmh_rsform_BaseURL; // ← PRODUCTION
        const url = `${RS_FORM_BASE}${suffix}/${id}?updatedby=admin&token=${localStorage.getItem("token")}&viewMode=true&rsVersion=${encodeURIComponent(rsVersion || "")}`;
        window.open(url, "_blank", "noopener,noreferrer");
    };

    useEffect(() => {
        trelloCheckList(id);
    }, [isOpen]);

    // listOrders API se fetch inventoryId + projectVersion (per service)
    useEffect(() => {
        if (!id) return;
        axios.get(`${baseURL}internal/pm/listOrders/${id}`)
            .then((res) => {
                const orders = res.data?.orders || [];
                const mapById = {};
                const mapByName = {};
                orders.forEach((order) => {
                    (order.services || []).forEach((service) => {
                        const info = {
                            inventoryId: service.inventoryId || "",
                            projectVersion: service.projectVersion || "",
                            // FIX: pehle ye field yahan missing thi, isliye
                            // inventoryInfo?.hasRsform hamesha undefined aata
                            // tha (ID-map branch getInventoryInfo() me sabse
                            // pehle check hoti hai). Ab inventoryId/projectVersion
                            // ki tarah hasRsform bhi isi single source se aayega.
                            hasRsform: service.hasRsform || null,
                        };
                        if (service.ID) {
                            mapById[service.ID] = info;
                        }
                        const nameKey = normalizeName(service.name);
                        if (nameKey) {
                            mapByName[nameKey] = info;
                        }
                    });
                });
                setInventoryMap(mapById);
                setInventoryMapByName(mapByName);
            })
            .catch((err) => {
                console.error("listOrders fetch error:", err);
            });
    }, [id]);

    const AssignMember = (ID, itemId) => {
        setAssigned(true);
        console.log(selectedMemberId);
        let d = { checkItemID: itemId, memberID: selectedMemberId.value };

        console.log(d);
        var formData = new FormData();
        for (var i in d) {
            formData.append(i, d[i]);
        }
        API.AssignMemberToChekItem(ID, formData)
            .then((res) => {
                trelloCheckList(id);
                trelloCommentList(id, 20, 1);
                setSelectedItem("");
                setEditItem(null);
                setAssigned(false);
                onMemberClose();

                toast.success(res.data.message, {
                    position: "top-right",
                });
            })
            .catch((err) => {
                toast.error("Oops! There is error assigning member", {
                    position: "top-right",
                });
                onMemberClose();
                setAssigned(false);
            });
    };

    const handleUpdateCheck = (type, e, ID) => {
        setLoader(true);
        let d = {};
        let checkItemID = "";
        if (type === "task") {
            d.checkItemStatus = e?.target?.checked ? "complete" : "incomplete";
            d.checkItemID = e?.target?.id;
        } else if (type === "taskName") {
            d.checkItemName = taskName;
            d.checkItemID = e?.target?.id;
            d.checkItemStatus = "incomplete";
        }
        console.log(d);
        var formData = new FormData();
        for (var i in d) {
            formData.append(i, d[i]);
        }
        API.updateTrelloCheckItem(ID, formData)
            .then((res) => {
                trelloCheckList(id);
                trelloCommentList(id, 20, 1);
                setEditItem(null);
                setLoader(false);
            })
            .catch((err) => {
                toast.error("Oops! There is error from trello", {
                    position: "top-right",
                });
                setLoader(false);
            });
    };

    const handleAddItem = (clId, pos) => {
        setLoader(true);
        let data = {
            checkItemName: taskName,
        };
        API.createCheckList(clId, data)
            .then((res) => {
                trelloCheckList(id);
                trelloCommentList(id, 20, 1);
                setIsAddItem(null);
                setLoader(false);
            })
            .catch((res) => {
                toast.error("Oops! There is error from trello", {
                    position: "top-right",
                });
                setLoader(false);
            });
    };

    const handleRemoveItem = (clId, itemId) => {
        setLoader(true);
        let data = {
            checkItemID: itemId,
        };
        var formData = new FormData();
        for (var i in data) {
            formData.append(i, data[i]);
        }
        API.removeCheckListItem(clId, formData)
            .then((res) => {
                trelloCheckList(id);
                trelloCommentList(id, 20, 1);
                setSelectedItem("");
                setIsAddItem(null);
                setLoader(false);
            })
            .catch((res) => {
                toast.error("Oops! There is error from trello", {
                    position: "top-right",
                });
                setLoader(false);
            });
    };

    const handleNewCheckList = () => {
        setLoader(true);

        API.createCheckList(id, { name: taskName })
            .then((res) => {
                trelloCheckList(id);
                trelloCommentList(id, 20, 1);
                setIsAddList(false);
                setLoader(false);
            })
            .catch((err) => {
                toast.error("Oops! There is error from trello", {
                    position: "top-right",
                });
                setLoader(false);
            });
    };

    return (
        <>
            <div>
                {isLoader == true ? (
                    <div
                        className="ap-flex ap-w100 ap-flex-center"
                        style={{ alignItems: "center", height: "300px" }}
                    >
                        <LoaderDiv>
                            <SpinLoader />
                        </LoaderDiv>
                    </div>
                ) : (
                    <>
                        <Collapse in={isAddList} mt={5} mb={5}>
                            <div className="ap-flex ap-w100">
                                <Textarea
                                    placeholder="Please enter an item"
                                    size="sm"
                                    mt={2}
                                    mb={2}
                                    w="100%"
                                    value={taskName}
                                    onChange={(e) => {
                                        props.SetCommentPage(1);
                                        setTaskName(e.target.value);
                                    }}
                                />
                            </div>
                            <div className="ap-flex ap-w100" style={{ marginTop: "10px" }}>
                                <Button
                                    className="submit_right_outline"
                                    variant="outline"
                                    size="sm"
                                    onClick={() => {
                                        props.SetCommentPage(1);
                                        handleNewCheckList();
                                    }}
                                >
                                    {!isAddItem ? "Add an item" : "Add"}
                                </Button>
                                <Button
                                    colorScheme="red"
                                    variant="ghost"
                                    size="sm"
                                    ml={3}
                                    onClick={() => setIsAddList((prev) => !prev)}
                                >
                                    Close
                                </Button>
                            </div>
                        </Collapse>

                        {state.trelloCardInfo.cardInfo?.idChecklists !== null ? (
                            <>
                                {state.trelloCheckList?.list?.map((cl, clIndex) => (
                                    <>
                                        <div className="ap-flex ap-w100">
                                            <div className="ap-flex ap-flex-center-center ">
                                                <Text
                                                    color="gray.500"
                                                    fontSize="2xl"
                                                    casing="capitalize"
                                                >
                                                    {cl?.name}
                                                </Text>
                                            </div>
                                        </div>
                                        {cl?.services?.map((cItem, cItemIndex) => {
                                            // NEW: ek hi jagah se inventory info nikal rahe hain
                                            // (cItem ke apne fields -> ID map -> name map, is priority me)
                                            const inventoryInfo = getInventoryInfo(cItem);
                                            return (
                                                <div
                                                    className={`ap-flex ap-w100 ${editItem === cItem?.ID ? "" : "ap-flex-space-bw"}`}
                                                    key={cItemIndex}
                                                    style={{ alignItems: "center" }}
                                                >
                                                    <div
                                                        className={`ap-flex ap-flex-center-center ${editItem === cItem?.ID ? "" : "ap-w100"}`}
                                                        style={
                                                            editItem === cItem?.id
                                                                ? {
                                                                    alignItems: "flex-start",
                                                                    justifyContent: "flex-start",
                                                                }
                                                                : {
                                                                    alignItems: "flex-start",
                                                                    width: editItem === cItem?.ID ? "" : "55%",
                                                                }
                                                        }
                                                    >
                                                        <Checkbox
                                                            size="lg"
                                                            colorScheme="green"
                                                            isChecked={cItem?.status === "complete"}
                                                            ml={5}
                                                            mb={0}
                                                            name={cItem?.name}
                                                            id={cItem?.ID}
                                                            onChange={(e) => {
                                                                props.SetCommentPage(1);
                                                                handleUpdateCheck("task", e, cl?.ID);
                                                            }}
                                                        >
                                                            {editItem !== cItem?.ID && (
                                                                <div
                                                                    style={{ minWidth: "185px", display: "flex" }}
                                                                >
                                                                    <div>
                                                                        <Text
                                                                            color="gray.500"
                                                                            fontSize="md"
                                                                            width="100%"
                                                                            mb={0}
                                                                        >
                                                                            {cItem?.name}
                                                                        </Text>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </Checkbox>
                                                    </div>
                                                    {editItem === cItem?.ID && (
                                                        <div className={`ap-flex ap-flex-center ap-w100`}>
                                                            <Collapse
                                                                style={{ width: "100%" }}
                                                                in={editItem === cItem?.ID}
                                                                mt={5}
                                                                mb={5}
                                                            >
                                                                <div className="ap-flex ap-w100">
                                                                    <Textarea
                                                                        placeholder="Please enter an item"
                                                                        size="sm"
                                                                        ml={2}
                                                                        mb={2}
                                                                        w="100%"
                                                                        value={taskName}
                                                                        onChange={(e) => {
                                                                            setTaskName(e.target.value);
                                                                        }}
                                                                    />
                                                                </div>
                                                                <div className="ap-flex ap-w100">
                                                                    <Button
                                                                        className="submit_right_outline"
                                                                        variant="outline"
                                                                        size="sm"
                                                                        ml={2}
                                                                        id={cItem?.ID}
                                                                        onClick={(e) => {
                                                                            props.SetCommentPage(1);
                                                                            handleUpdateCheck("taskName", e, cl?.ID);
                                                                        }}
                                                                    >
                                                                        Update
                                                                    </Button>
                                                                    <Button
                                                                        colorScheme="red"
                                                                        variant="ghost"
                                                                        size="sm"
                                                                        ml={1}
                                                                        onClick={() => setEditItem(null)}
                                                                    >
                                                                        Close
                                                                    </Button>
                                                                </div>
                                                            </Collapse>
                                                        </div>
                                                    )}
                                                    {/* NEW: yaha ab sirf "Assigned To" text hai — RS form/inventory
                                                    icons yaha se hata kar niche wale Assign-Member group me
                                                    move kar diye hain, taaki sab action icons ek hi jagah rahein
                                                    aur "bahut door" wala UI gap na ho */}
                                                    <div
                                                        className="ap-flex"
                                                        style={{
                                                            width: "15%",
                                                            flexDirection: "column",
                                                            justifyContent: "center",
                                                        }}
                                                    >
                                                        {cItem?.assignedTo?.name && (
                                                            <Text
                                                                color="#000000c4"
                                                                fontSize="sm"
                                                                width="100%"
                                                                mb={0}
                                                                style={{
                                                                    width: "auto",
                                                                    fontStyle: "italic",
                                                                }}
                                                            >
                                                                Assigned To: {cItem?.assignedTo?.name}
                                                            </Text>
                                                        )}
                                                    </div>
                                                    {/* NEW: width 15% -> 30% kiya kyunki ab is group me RS form
                                                    view (eye) icon aur inventory box icon bhi shamil ho gaye hain,
                                                    Assign/Edit/Upload/Delete ke saath ek hi row me, dono green color me */}
                                                    <div className="ap-flex " style={{ width: "30%" }}>
                                                        {/* NEW: dono icons ko fixed-width reserved slot diya (32px)
                                                        taaki agar eye icon (hasRsform false) ya box icon
                                                        (projectVersion !== v2) na ho, to uski jagah khali rahe
                                                        — box eye ki jagah shift/merge na ho, dono ki apni-apni
                                                        column position hamesha same rahe har row me */}
                                                        <Flex w="32px" h="32px" align="center" justify="center">
                                                            {/* UPDATE: rsSubmitted === false pe eye (read-only) button
                                                            hide rahega, chahe hasRsform truthy ho. hasRsform ka
                                                            existing check waisa hi rakha hai, sirf rsSubmitted ki
                                                            extra condition add ki hai. */}
                                                            {cItem?.hasRsform && cItem?.rsSubmitted ? (
                                                                <Tooltip
                                                                    label="View RS Form (Read-only)"
                                                                    size="sm"
                                                                    fontSize="sm"
                                                                    color="white"
                                                                    bg="gray.400"
                                                                    placement="top"
                                                                >
                                                                    <IconButton
                                                                        colorScheme="green"
                                                                        size="sm"
                                                                        variant="ghost"
                                                                        icon={<ViewIcon />}
                                                                        onClick={() =>
                                                                            openRsFormViewMode(
                                                                                getRsFormSuffix(cItem?.rsformUrlSuffix),
                                                                                cItem?.rsVersion
                                                                            )
                                                                        }
                                                                    />
                                                                </Tooltip>
                                                            ) : null}
                                                        </Flex>
                                                        <Flex w="32px" h="32px" align="center" justify="center">
                                                            {inventoryInfo?.projectVersion === "v2" ? (
                                                                <Tooltip
                                                                    label="View Product Inventory"
                                                                    size="sm"
                                                                    fontSize="sm"
                                                                    color="white"
                                                                    bg="gray.400"
                                                                    placement="top"
                                                                >
                                                                    <IconButton
                                                                        colorScheme="green"
                                                                        size="sm"
                                                                        variant="ghost"
                                                                        icon={
                                                                            <span
                                                                                role="img"
                                                                                aria-label="Product Inventory"
                                                                                style={{
                                                                                    fontSize: "16px",
                                                                                    filter: "grayscale(1) brightness(0.6) sepia(1) hue-rotate(70deg) saturate(3)",
                                                                                }}
                                                                            >
                                                                                📦
                                                                            </span>
                                                                        }
                                                                        onClick={() =>
                                                                            window.open(
                                                                                `/home/ap/product-inventory/tabs/${inventoryInfo?.inventoryId}`,
                                                                                "_blank",
                                                                                "noopener,noreferrer"
                                                                            )
                                                                        }
                                                                    />
                                                                </Tooltip>
                                                            ) : null}
                                                        </Flex>
                                                        <div className="ap-flex ap-flex-center-center">
                                                            <Tooltip
                                                                label="Assign member"
                                                                size="sm"
                                                                fontSize="sm"
                                                                color="white"
                                                                bg="gray.400"
                                                                placement="right"
                                                            >
                                                                <IconButton
                                                                    colorScheme="green"
                                                                    size="sm"
                                                                    variant="ghost"
                                                                    icon={<Icons.UserFilled />}
                                                                    onClick={() => {
                                                                        onMemberOpen();
                                                                        setSelectedItem({
                                                                            id: cl?.ID,
                                                                            itemId: cItem?.ID,
                                                                            name: cItem?.name,
                                                                        });
                                                                    }}
                                                                />
                                                            </Tooltip>
                                                        </div>
                                                        {editItem !== cItem?.ID && (
                                                            <div className="ap-flex ap-flex-center-center">
                                                                <Tooltip
                                                                    label="Edit item"
                                                                    size="sm"
                                                                    fontSize="sm"
                                                                    color="white"
                                                                    bg="gray.400"
                                                                    placement="right"
                                                                >
                                                                    <IconButton
                                                                        colorScheme="green"
                                                                        size="sm"
                                                                        variant="ghost"
                                                                        icon={<Icons.Edit />}
                                                                        onClick={() => {
                                                                            setEditItem(cItem?.ID);
                                                                            setTaskName(cItem?.name);
                                                                            setIsAddList(false);
                                                                        }}
                                                                    />
                                                                </Tooltip>
                                                            </div>
                                                        )}
                                                        <Tooltip
                                                            label="Upload attachments"
                                                            size="sm"
                                                            fontSize="sm"
                                                            color="white"
                                                            bg="gray.400"
                                                            placement="right"
                                                        >
                                                            <IconButton
                                                                colorScheme="green"
                                                                size="sm"
                                                                variant="ghost"
                                                                icon={<Icons.ArrowUpward />}
                                                                onClick={() => {
                                                                    onUploadOpen();
                                                                    setUploadData({
                                                                        serviceID: cItem?.ID,
                                                                        orderID: cl?.ID,
                                                                        inventoryId: inventoryInfo?.inventoryId || null,
                                                                        projectVersion: inventoryInfo?.projectVersion || null,
                                                                        // FIX: ab teeno fields (inventoryId,
                                                                        // projectVersion, hasRsform) ek hi source
                                                                        // (inventoryInfo) se aa rahe hain — pehle
                                                                        // hasRsform alag se cItem se le raha tha,
                                                                        // jo inventoryId/projectVersion ke source
                                                                        // se mismatch ho sakta tha.
                                                                        hasRsform: inventoryInfo?.hasRsform || null,
                                                                    });
                                                                }}
                                                            />
                                                        </Tooltip>
                                                        <div className="ap-flex ap-flex-center-center">
                                                            <Tooltip
                                                                label="Delete item"
                                                                size="sm"
                                                                fontSize="sm"
                                                                color="white"
                                                                bg="gray.400"
                                                                placement="right"
                                                            >
                                                                <IconButton
                                                                    colorScheme="green"
                                                                    size="sm"
                                                                    variant="ghost"
                                                                    icon={<Icons.Delete />}
                                                                    onClick={() => {
                                                                        onDeleteOpen();
                                                                        setSelectedItem({
                                                                            id: cl?.ID,
                                                                            itemId: cItem?.ID,
                                                                            name: cItem?.name,
                                                                        });
                                                                    }}
                                                                />
                                                            </Tooltip>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                        <Collapse
                                            in={isAddItem === cl?.ID && editItem === null}
                                            mt={5}
                                            mb={5}
                                        >
                                            <div className="ap-flex ap-w100">
                                                <Textarea
                                                    placeholder="Please enter an item"
                                                    size="sm"
                                                    ml={5}
                                                    mt={2}
                                                    mb={2}
                                                    w="100%"
                                                    value={taskName}
                                                    onChange={(e) => {
                                                        setTaskName(e.target.value);
                                                    }}
                                                />
                                            </div>
                                        </Collapse>
                                        {editItem === null && (
                                            <div
                                                className="ap-flex ap-w100"
                                                style={{ marginTop: "10px" }}
                                            >
                                                <Button
                                                    className="submit_right_outline"
                                                    variant="outline"
                                                    size="sm"
                                                    ml={5}
                                                    onClick={() => {
                                                        if (!isAddItem) {
                                                            setIsAddItem(cl?.ID);
                                                            setTaskName("");
                                                            setIsAddList(false);
                                                        } else {
                                                            props.SetCommentPage(1);
                                                            handleAddItem(cl?.ID, cl?.pos);
                                                        }
                                                    }}
                                                >
                                                    {isAddItem !== cl?.ID ? "Add an item" : "Add"}
                                                </Button>
                                                {isAddItem !== null && isAddItem === cl?.ID && (
                                                    <Button
                                                        colorScheme="red"
                                                        variant="ghost"
                                                        size="sm"
                                                        ml={3}
                                                        onClick={() => setIsAddItem((prev) => !prev)}
                                                    >
                                                        Close
                                                    </Button>
                                                )}
                                            </div>
                                        )}
                                    </>
                                ))}
                            </>
                        ) : (
                            <div className="ap-flex ap-w100 ap-flex-center-center">
                                <Text as="i" size="3xl">
                                    There is no checklist, please create new one.
                                </Text>
                            </div>
                        )}
                    </>
                )}
            </div>

            <Modal isOpen={isMemberOpen} onClose={onMemberClose}>
                <ModalOverlay />
                <ModalContent maxH="38rem" minH="15rem">
                    <ModalHeader
                        style={{ justifyContent: "space-between", display: "flex" }}
                    >
                        Assign {selectedItem?.name}
                        <div>
                            <CloseButton onClick={onMemberClose} />
                        </div>
                    </ModalHeader>
                    <ModalBody>
                        <span className="ap-flex ap-fsm ap-fwmd ap-w100">
                            Select Member
                        </span>

                        <Select
                            showSearch
                            size="middle"
                            labelInValue
                            placeholder="Please Select Member name"
                            onChange={(data) => {
                                setSelectedMemberId(data);
                            }}
                            style={{ width: "100%" }}
                            filterOption={(input, option) =>
                                option.props.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                            }
                        >
                            {state.trelloCardInfo?.cardInfo?.members?.map((member) => (
                                <Option value={member?.ID} key={member?.ID}>
                                    {member?.name}
                                </Option>
                            ))}
                        </Select>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            className="submit_right1"
                            isLoading={isAssigned}
                            onClick={() => {
                                AssignMember(selectedItem?.id, selectedItem?.itemId);
                            }}
                            size="sm"
                            style={{ margin: "0 5px" }}
                        >
                            Assign
                        </Button>
                        <Button
                            className="submit_right1"
                            onClick={onMemberClose}
                            size="sm"
                            style={{ margin: "0 5px" }}
                        >
                            Close
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
            <AlertDialog isOpen={isDeleteOpen} onClose={onDeleteClose}>
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize="lg" fontWeight="bold">
                            Delete Checklist Item
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            Are you sure? You want to Delete {selectedItem?.name}!!
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button onClick={onDeleteClose} size="sm">
                                Cancel
                            </Button>
                            <Button
                                colorScheme="red"
                                size="sm"
                                onClick={() => {
                                    props.SetCommentPage(1);
                                    handleRemoveItem(selectedItem?.id, selectedItem?.itemId);
                                    onDeleteClose();
                                }}
                                ml={3}
                            >
                                Delete
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
            <Modal isOpen={isUploadOpen} onClose={onUploadClose} size="4xl">
                <ModalOverlay />
                <ModalContent maxH="38rem" minH="30rem" minW="30rem">
                    <UploadAttachment
                        onClose={onUploadClose}
                        isCheklist={true}
                        orderID={uploadData?.orderID}
                        serviceID={uploadData?.serviceID}
                        inventoryId={uploadData?.inventoryId}
                        projectVersion={uploadData?.projectVersion}
                        // UPDATE: hasRsform pass kiya taaki UploadAttachment
                        // andar decide kar sake ki source/output (inventory)
                        // form dikhana hai ya purana single-file (project) form.
                        hasRsform={uploadData?.hasRsform}
                    />
                </ModalContent>
            </Modal>
        </>
    );
};

export default TrelloCheckList;